import { appTrelloLabels, cardIdentifier } from "../../assets/config/constants";

const complains = {
    state: { assignees: null, trelloLabels: null, trelloListIds: null, cardsData: null },
    mutations: {
        setAssignees(state, payload) {
            state.assignees = payload;
        },
        setTrelloLabels(state, payload) {
            state.trelloLabels = payload;
        },
        setTrelloListIds(state, payload) {
            state.trelloListIds = payload;
        },
        setCardsData(state, payload) {
            state.cardsData = payload;
        }
    },
    actions: {
        async fetchAllTrelloData(context) {
            const user = context.rootState.auth.user;
            const complainsListName = process.env.PROD_VUE_APP_TRELLO_LIST_NAME.toLowerCase();
            const resolvedListName = process.env.PROD_VUE_APP_TRELLO_RESOLVED_LIST_NAME.toLowerCase();
            try {
                const [members, labels, lists] = await Promise.all([
                    fetchFromTrello("members"),
                    fetchFromTrello("labels"),
                    fetchFromTrello("lists"),
                ]);
                const listIds = lists.reduce((acc, list) => {
                    if (list.name.toLowerCase() === complainsListName.toLowerCase()) {
                        acc.complainsListId = list.id;
                    } else if (list.name.toLowerCase() === resolvedListName) {
                        acc.resolvedListId = list.id;
                    }
                    return acc;
                }, { complainsListId: null, resolvedListId: null });

                const appLabels = getAppLabels(labels);
                fetchTrelloCards(context, appLabels, user, members, listIds);
                console.log(listIds,"listIds================")

                context.commit('setAssignees', members);
                context.commit('setTrelloLabels', appLabels);
                context.commit('setTrelloListIds', listIds);
            } catch (error) {
                console.error('Error fetching Trello data:', error);
            }
        },
        async fetchTrelloCards(context) {
            
            const {trelloLabels, trelloListIds, assignees } = context.state
            const user = context.rootState.auth.user;
            const cards = await fetchFromTrello("cards", context);
            const cardsData = processCards(cards.cards, trelloLabels, user, assignees, trelloListIds);
            context.commit('setCardsData', cardsData);
        },
        async updateCardsData(context, { updatedCard }) {
            const {trelloLabels, trelloListIds, assignees, cardsData } = context.state;
            const card = modifyData(updatedCard, assignees, trelloListIds, trelloLabels);
            const updatedCardsData = [card, ...cardsData]
            context.commit('setCardsData', updatedCardsData);
          }
    },
    getters: {
        allAssignees: state => () => state.assignees,
        cardsData: state => () => state.cardsData
    }
};

async function fetchTrelloCards(context, appLabels, user, members, listIds) {
    const cards = await fetchFromTrello("cards", context);
    const cardsData = processCards(cards.cards, appLabels, user, members, listIds);
    context.commit('setCardsData', cardsData);
}

function processCards(cards, appLabels, user, assignees, listIds) {
    const {resolvedListId, complainsListId} = listIds
    const teamComplainCards = cards
    .filter(card => [resolvedListId, complainsListId].includes(card.idList))
    .sort((a, b) => {
      // Convert dateLastActivity to timestamps for comparison
      const dateA = new Date(a.dateLastActivity).getTime();
      const dateB = new Date(b.dateLastActivity).getTime();
  
      // Sort in descending order (most recent first)
      return dateB - dateA;
    });
    let processedCards;

    if (user.role === 'admin') {
        processedCards = teamComplainCards;
    } else {
        processedCards = teamComplainCards.filter(card => 
            card.name.includes(user.email) || 
            (!card.name.includes(user.email) && card.idLabels.includes(appLabels.generalLabelId))
        );
    }

    processedCards = processedCards.map(card => modifyData(card, assignees, listIds, appLabels));

    return processedCards;
}

function modifyData(card, assignees, listIds, appLabels){
        const assignee = assignees.find(member => member.id === card.idMembers[0]);
        const assigneeName = assignee ? assignee.fullName.includes('_')
            ? assignee.fullName.split('_').map(word => word[0].toUpperCase() + word.slice(1).toLowerCase()).join(' ')
            : assignee.fullName : null;

        const isHighPriority = card.idLabels.includes(appLabels.highPriorityLabelId);
        const isPersonal = card.idLabels.includes(appLabels.personalLabelId);
        const status = card.idList === listIds.resolvedListId ? "Resolved" : "Pending";

        return {
            ...card,
            assigneeName,
            isHighPriority,
            isPersonal,
            status
        };
}

async function fetchFromTrello(dataToFetch, context) {
    const apiKey = process.env.PROD_VUE_APP_ACTIVITY_TRELLO_API_KEY;
    const token = process.env.PROD_VUE_APP_ACTIVITY_TRELLO_TOKEN;
    const boardId = process.env.PROD_VUE_APP_TRELLO_BOARD_ID;

    const APIEndPoint = dataToFetch === "cards" ? context.rootState.auth.user.role === "admin" ? 
    `https://api.trello.com/1/search?idBoards=${boardId}&key=${apiKey}&token=${token}&query=${cardIdentifier}&modelTypes=cards&cards_limit=${1000}`: 
        `https://api.trello.com/1/search?idBoards=${boardId}&key=${apiKey}&token=${token}&query=${context.rootState.auth.user.email}&modelTypes=cards&cards_limit=${1000}`
        : `https://api.trello.com/1/boards/${boardId}/${dataToFetch}?key=${apiKey}&token=${token}`;

    const response = await fetch(APIEndPoint);

    if (!response.ok) {
        throw new Error(`Network response was not ok for dataToFetch: ${dataToFetch}`);
    }
    return response.json();
}

function getAppLabels(labels) {
    return labels
        .filter(item => appTrelloLabels.some(label => label.toLowerCase() === item.name.toLowerCase()))
        .reduce((acc, item) => {
            const key = convertToCamelCase(item.name);
            acc[key] = item.id;
            return acc;
        }, {});
}

function convertToCamelCase(str) {
    return str
        .replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, (match, index) =>
            index === 0 ? match.toLowerCase() : match.toUpperCase()
        )
        .replace(/\s+/g, '') + 'LabelId';
}

export default complains;



// WEBPACK FOOTER //
// ./src/store/modules/complains.js